import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const AddReceipt: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2H7C5.34315 2 4 3.22104 4 4.72727V20.3155C4 21.0745 4.81248 21.5568 5.47885 21.1934L8.33049 19.6379C8.72397 19.4233 9.22762 19.4797 9.55209 19.7746L11.2929 21.3572C11.6834 21.7122 12.3166 21.7122 12.7071 21.3572L14.4479 19.7746C14.7724 19.4797 15.276 19.4233 15.6695 19.6379L18.5211 21.1934C19.1875 21.5568 20 21.0745 20 20.3155V4.72727C20 3.22104 18.6569 2 17 2Z"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="11" y="6" width="2" height="10" rx="1" fill={color} />
      <rect
        x="17"
        y="10"
        width="2"
        height="10"
        rx="1"
        transform="rotate(90 17 10)"
        fill={color}
      />
    </svg>
  );
};

export default AddReceipt;
